import { SelectableModel } from '../models/selectable/selectable.model';
import { SelectableStylingModel } from '../models/selectable/selectable-styling.model';

export const /** @type {?} */ RadioTemplates = {
  defaultTemplate: {
    property: new SelectableModel({
      display: true,
      disable: false,
      value: 'radio',
      item: 'Radio Button',
      checked: false,
      itemPosition: 'after'
    }),
    style : new SelectableStylingModel({
      container: {
        class: 'cf-default-container',
        dynamicClass: ''
      },
      button: {
        themeColor: 'primary'
      }
    })
  }
}
